class FavouritePageNodes {

  constructor(currentUserBasePath, apiClient) {

    this.basePath = `${currentUserBasePath}/favourite-page-nodes`;
    this.apiClient = apiClient;

  }

  async createFavouritePageNode(favouriteNode) {

    const path = this.basePath;

    return this.apiClient.post(path, {}, {}, favouriteNode);

  }

  async getAllPrivateFavouritePageNodes(projection) {

    const path = this.basePath;

    return this.apiClient.get(path, {}, { projection });

  }

  async getAllPublicFavouritePageNodes(projection) {

    const path = `${this.basePath}/public`;

    return this.apiClient.get(path, {}, { projection });

  }

  async unpublicFavouritePageNodeById(favouritePageNodeId) {

    const path = `${this.basePath}/:favouritePageNodeId/public`;

    return this.apiClient.delete(path, { favouritePageNodeId }, {});

  }

  async deleteFavouritePageNodeById(favouritePageNodeId) {

    const path = `${this.basePath}/:favouritePageNodeId`;

    return this.apiClient.delete(path, { favouritePageNodeId }, {});

  }

  async createFavouritePageNodeCloner(favouritePageNodeId, pageId) {

    const path = `${this.basePath}/:favouritePageNodeId/clones`;

    return this.apiClient.post(path, { favouritePageNodeId }, {}, { pageId });

  }

  async getFavouritePageNodeClonerById(favouritePageNodeId, clonerId) {

    const path = `${this.basePath}/:favouritePageNodeId/clones/:clonerId`;

    return this.apiClient.get(path, { favouritePageNodeId, clonerId }, {});

  }

}

export default FavouritePageNodes;